import { app_url } from 'app_config';
import Breadcrumb from 'components/Common/Breadcrumb';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Container, CardBody, Card } from "reactstrap"
import { axiosbaseurl } from 'configure';
import LoadingButton from 'components/Common/LoadingButton';

import all_modules from './modules-data';
import { usePermissionData } from 'AppContext';
import PermittedComponent from 'components/Common/PermittedComponent';

const AddRole = () => {

    // Individual states for each field
    const [roleName, setRoleName] = useState("");
    const [loading, setLoading] = useState(false)

    const [viewAll, setViewAll] = useState(false)
    const [addAll, setAddAll] = useState(false)
    const [editAll, setEditAll] = useState(false)
    const [deleteAll, setDeleteAll] = useState(false)
    const [isFixedHead, setIsFixedHead] = useState(false)
    const [allModule, setModules] = useState(all_modules);

    document.title = "Add Role | Peacock Accountants Limited";

    useEffect(() => {

        document.addEventListener('scroll', () => {
            if (window.scrollY > 203)
                setIsFixedHead(true)
            else
                setIsFixedHead(false)
        })

    }, [])
    const { checkAccess } = usePermissionData()
    const module_id = 22;

    const navigate = useNavigate()

    // changeing permissions
    const updateModule = (moduleId, property) => {
        const updatedModules = allModule.map(mod => {
            if (mod.id === moduleId) {
                return { ...mod, [property]: (mod[property] === 0 ? 1 : 0) };
            }
            return mod;
        });
        setModules(updatedModules);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (roleName) {
            try {
                setLoading(true)
                let permissions = allModule?.map((module) =>
                    (`${module.id},${module.view},${module.add},${module.edit},${module.delete}`))

                const response = await axiosbaseurl.post("/roles-and-permission",
                    { name: roleName, permissions: JSON.stringify(permissions) })

                if (response.data.success) {
                    swal("", response.data.message, "success")
                    setTimeout(() => {
                        navigate(`${app_url}roles-and-permissions`)
                    }, 1000)
                }

            } catch (error) {
                console.log(error)
                swal("", error.response.data.message || error.message || "Something went Wrong", "error")

            } finally {
                setLoading(false)
            }
        }
    }

    // Add this new useEffect to monitor checkbox states
    useEffect(() => {
        // Check if all view permissions are checked
        const allViewChecked = allModule.every(module => module.view === 1)
        setViewAll(allViewChecked)

        // Check if all add permissions are checked (only for modules with isAdd)
        const allAddChecked = allModule
            .filter(module => module.isAdd)
            .every(module => module.add === 1)
        setAddAll(allAddChecked)

        // Check if all edit permissions are checked (only for modules with isEdit)
        const allEditChecked = allModule
            .filter(module => module.isEdit)
            .every(module => module.edit === 1)
        setEditAll(allEditChecked)

        // Check if all delete permissions are checked (only for modules with isDelete)
        const allDeleteChecked = allModule
            .filter(module => module.isDelete)
            .every(module => module.delete === 1)
        setDeleteAll(allDeleteChecked)
    }, [allModule])

    function changeAllPermission(type, value, setCheckValue) {
        setCheckValue(!value);

        const updated = allModule.map((item) => {
            return {
                ...item,
                [type]: value ? 0 : 1 // dynamically update the property based on the 'type'
            };
        })

        setModules(updated)
    }

    return (
        <>
            <div className="page-content mb-5">
                <Container fluid >
                    <Breadcrumb
                        title={"Dashboard"}
                        breadcrumbItem={"Add Role"}
                    />

                    <Card className='' >
                        <CardBody >
                            <PermittedComponent isAccess={checkAccess(module_id, "add")}>
                                <form onSubmit={handleSubmit} >
                                    <div className='row justify-content-between mb-4'>
                                        <div className="col-md-4 mb-3">
                                            <label>Role Name <span className='text-danger'>*</span></label>
                                            <input
                                                type="text"
                                                value={roleName}
                                                placeholder='Enter Role Name'
                                                onChange={(e) => setRoleName(e.target.value)}
                                                className="form-control input-field"
                                                required
                                            />
                                        </div>
                                        <div className='col-md-4 text-end'>
                                            <LoadingButton loading={loading} />
                                            <button type='button' onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                                                <i className="fas fa-arrow-left me-3"></i>
                                                Back
                                            </button>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="table-responsive">
                                            <table className={`table custom-table text-center ${isFixedHead && 'role-table'}`} style={{ verticalAlign: "middle" }}>
                                                <thead className='table-primary'>
                                                    <tr>
                                                        <th className='text-start fw-bold border-end'>Modules</th>
                                                        <th className='fw-bold text-dark'>
                                                            <input type="checkbox"
                                                                checked={viewAll}
                                                                onChange={(e) =>
                                                                    changeAllPermission('view', !e.target.checked, setViewAll)}
                                                                className='me-2 form-check-input border-dark fs-5 m-0'
                                                            />
                                                            View
                                                        </th>
                                                        <th className='fw-bold text-dark'>
                                                            <input type="checkbox"
                                                                checked={addAll}
                                                                onChange={(e) =>
                                                                    changeAllPermission('add', !e.target.checked, setAddAll)}
                                                                className='me-2 form-check-input border-dark fs-5 m-0'
                                                            />
                                                            Add
                                                        </th>
                                                        <th className='fw-bold text-dark'>
                                                            <input type="checkbox"
                                                                checked={editAll}
                                                                onChange={(e) =>
                                                                    changeAllPermission('edit', !e.target.checked, setEditAll)}
                                                                className='me-2 form-check-input border-dark fs-5 m-0'
                                                            />
                                                            Edit
                                                        </th>
                                                        <th className='fw-bold text-dark'>
                                                            <input type="checkbox"
                                                                checked={deleteAll}
                                                                onChange={(e) =>
                                                                    changeAllPermission('delete', !e.target.checked, setDeleteAll)}
                                                                className='me-2 form-check-input border-dark fs-5 m-0'
                                                            />
                                                            Delete
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {allModule.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <th className='text-start border-end'>
                                                                    <input
                                                                        id="roleId"
                                                                        value={item.id}
                                                                        type='hidden'
                                                                        className="display-none bd-text-center"
                                                                    />
                                                                    <span className='text-primary'>{item.locatedAt || ''}</span> {item.module}
                                                                </th>

                                                                <td data-column="View" >
                                                                    <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                        <div className="form-check form-switch form-switch-md">
                                                                            <input
                                                                                type="checkbox"
                                                                                className={`form-check-input fs-2 ${item.id}`}
                                                                                checked={item.view === 1}
                                                                                onChange={() => updateModule(item.id, 'view')}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </td>

                                                                <td data-column="Add">
                                                                    {
                                                                        item.isAdd ?
                                                                            <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                                <div className="form-check form-switch form-switch-md">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input fs-2"
                                                                                        checked={item.add === 1}
                                                                                        onChange={() => updateModule(item.id, 'add')}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            : <div className='ms-0 mt-4'>--</div>
                                                                    }
                                                                </td>

                                                                <td data-column="Edit">
                                                                    {
                                                                        item.isEdit ?
                                                                            <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                                <div className="form-check form-switch form-switch-md">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input fs-2"
                                                                                        checked={item.edit === 1}
                                                                                        onChange={() => updateModule(item.id, 'edit')}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            : <div className='ms-0 mt-4'>--</div>
                                                                    }
                                                                </td>

                                                                <td data-column="Delete">
                                                                    {
                                                                        item.isDelete ?
                                                                            <div className="d-flex align-items-center pt-2 justify-content-center ps-5 ">
                                                                                <div className="form-check form-switch form-switch-md">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input fs-2"
                                                                                        checked={item.delete === 1}
                                                                                        onChange={() => updateModule(item.id, 'delete')}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            : <div className='ms-0 mt-4'>--</div>
                                                                    }
                                                                </td>

                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                            </PermittedComponent>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </>
    )
}

export default AddRole